import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-add-answer-rewording',
  templateUrl: './add-answer-rewording.component.html',
  styleUrls: ['./add-answer-rewording.component.scss']
})
export class AddAnswerRewordingComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  form: FormGroup;
  TITLE: string = "Add New Answer"
  constructor(public dialogRef: MatDialogRef<AddAnswerRewordingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder) { }

  ngOnInit() {
    const { text } = this.data;
    this.form = this.fb.group({
      answer: [text, Validators.compose([Validators.required])],
    })
    if (text) {
      this.TITLE = "Edit Answer";
    }
  }

  onSave(f: any) {
    if (this.form.valid) {
      const answers = this.data.answers as Array<any>;
      const { answer } = f;
      const findAnswer = Array.isArray(answers) && answers.find(m => m === `${answer}`.trim());
      if (findAnswer) {
        alert("Sorry answer already exist.");
        return;
      }
      answers.push(answer)
      this.data.answers = answers
      this.form.reset();
      this.inputEl.nativeElement.focus()
    }
  }

}
